var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{directives:[{name:"svg",rawName:"v-svg"}],class:("icon " + (_vm.icon.slug)),attrs:{"size":_vm.icon.size,"symbol":_vm.icon.slug}})}
var staticRenderFns = []

export { render, staticRenderFns }